import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import CaseTypeStage from '../../entities/caseTypeStage';
import DeadlineRule from '../../entities/deadlineRule';
import MatterStage from '../../entities/matterStage';

/*
 * Delete/nullify anywhere this caseTypeStage is used in other entities
 *
 * @param {CaseTypeStage} caseTypeStage
 */
export function deleteCaseTypeStage(caseTypeStage: CaseTypeStage, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = caseTypeStage.id;
    }
    /* Simple delete usages */
        
    store.getState().deadlineRules
        .getMappingFor('caseTypeStageId', caseTypeStage.id)
        .filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D')
        .forEach(deadlineRuleTemp => {
            const _deadlineRule = deadlineRuleTemp.clone();
            _deadlineRule.status =  'U';
            _deadlineRule.addedOn = newHRTimestamp();
            _deadlineRule.addedBy = getCurrentUserId();
            _deadlineRule.importSource = targetImportSource;
            _deadlineRule.importId = mergeId;

            _deadlineRule.triggerStageId = null;
            store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
        });

    store.getState().matterStages
        .getMappingFor('caseTypeStageId', caseTypeStage.id)
        .filter(matterStageTemp => matterStageTemp.status !== 'D')
        .forEach(matterStageTemp => {
            const _matterStage = matterStageTemp.clone();
            _matterStage.status =  'U';
            _matterStage.addedOn = newHRTimestamp();
            _matterStage.addedBy = getCurrentUserId();
            _matterStage.importSource = targetImportSource;
            _matterStage.importId = mergeId;

            _matterStage.caseTypeStageId = null;
            store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
        });

    /* Remove the actual caseTypeStage */
    caseTypeStage.status = 'D';
    caseTypeStage.addedOn = newHRTimestamp();
    caseTypeStage.addedBy = getCurrentUserId();
    caseTypeStage.importSource = targetImportSource;
    caseTypeStage.importId = mergeId;
    store.dispatch(Actions.CaseTypeStageActions.removeCaseTypeStageQueue(caseTypeStage));
    
}

/*
 * Replace anywhere this caseTypeStage is used in other entities.
 *
 * @param {CaseTypeStage} caseTypeStage
 * @param {CaseTypeStage} replaceWith
 * @return {CaseTypeStage} - CaseTypeStage will have refs stripped away
 */
export function replaceCaseTypeStage(caseTypeStage: CaseTypeStage, replaceWith: CaseTypeStage, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = caseTypeStage.id;
    }
    /* Simple replace usages */
        
    store.getState().deadlineRules
        .getMappingFor('caseTypeStageId', caseTypeStage.id)
        .filter(deadlineRuleTemp => deadlineRuleTemp.status !== 'D')
        .forEach(deadlineRuleTemp => {
            const _deadlineRule = deadlineRuleTemp.clone();
            _deadlineRule.status =  'U';
            _deadlineRule.addedOn = newHRTimestamp();
            _deadlineRule.addedBy = getCurrentUserId();
            _deadlineRule.importSource = targetImportSource;
            _deadlineRule.importId = mergeId;

            _deadlineRule.triggerStageId = replaceWith.id;
            store.dispatch(Actions.DeadlineRuleActions.saveDeadlineRuleQueue(_deadlineRule));
        });

    store.getState().matterStages
        .getMappingFor('caseTypeStageId', caseTypeStage.id)
        .filter(matterStageTemp => matterStageTemp.status !== 'D')
        .forEach(matterStageTemp => {
            const _matterStage = matterStageTemp.clone();
            _matterStage.status =  'U';
            _matterStage.addedOn = newHRTimestamp();
            _matterStage.addedBy = getCurrentUserId();
            _matterStage.importSource = targetImportSource;
            _matterStage.importId = mergeId;

            _matterStage.caseTypeStageId = replaceWith.id;
            store.dispatch(Actions.MatterStageActions.saveMatterStageQueue(_matterStage));
        });

    return caseTypeStage;
}

/*
 * Determine the impact of deleting this caseTypeStage from other entities
 *
 * @param {CaseTypeStage} caseTypeStage
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactCaseTypeStage(caseTypeStage: CaseTypeStage) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const deadlineRuleTriggerStageIdImpact = state.deadlineRules
          .getMappingFor('caseTypeStageId', caseTypeStage.id)
          .filter(deadlineRule => deadlineRule.status !== 'D');

    deadlineRuleTriggerStageIdImpact.forEach(() => impacts.push('deadlineRules'));

    const matterStageCaseTypeStageIdImpact = state.matterStages
          .getMappingFor('caseTypeStageId', caseTypeStage.id)
          .filter(matterStage => matterStage.status !== 'D');

    matterStageCaseTypeStageIdImpact.forEach(() => impacts.push('matterStages'));

    return util.countDistinct(impacts);
}